import { FC } from 'react';
import { isString } from 'lodash';

import { ExternalLink, FeatureFlagDisplay } from '@app/components';
import { Feature } from '@app/constants';

import { SanitizedTextWithLinks } from './SanitizedTextWithLinks';

import css from './LCFooterLinks.module.scss';

export const LCFooterLinks: FC = () => (
  <FeatureFlagDisplay
    flagToMatch={{ name: Feature.LCFooter }}
    renderOn={({ config }) => (
      <div data-auto="lc-footer-links" className={css.container}>
        {config.map((linkConfig, index) => {
          if (isString(linkConfig)) {
            return (
              <SanitizedTextWithLinks key={index} rawHtmlString={linkConfig} />
            );
          }

          return (
            <ul key={index}>
              {linkConfig.map(({ label, href, imgSrc }) => (
                <li key={`${label}-${href}`}>
                  <ExternalLink href={href}>
                    {imgSrc ? (
                      <img width="100" src={imgSrc} alt={label} />
                    ) : (
                      label
                    )}
                  </ExternalLink>
                </li>
              ))}
            </ul>
          );
        })}
      </div>
    )}
  />
);
